<!-- Loading -->
<ng-container *ngIf="instructors == null">
    <div class="text-center">
        <span><i class="fa-solid fa-spinner fa-spin"></i></span>
    </div>
</ng-container>

<ng-container *ngIf="instructors != null">
    <div *ngFor="let instructor of instructors; let  i = index">
        <hr *ngIf="i != 0" class="light-divider p-0 m-0">
        <div class="py-1">
            {{instructor.firstName}} {{instructor.lastName}}
        </div>
    </div>
</ng-container>